/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EnrichService {

  constructor(private http: HttpClient) { }

  getSyncs(): Observable<any> {
    return this.http
      .get(
        `/api/v1/enrich_sync`
      );
  }

  savePartial(syncEnrichId: string, update: any): Observable<any> {
    return this.http
      .put(
        `/api/v1/enrich_sync/${syncEnrichId}`,
        update
      );
  }

  initSyncs(partner: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/enrich_sync`,
        { partner: partner }
      );
  }

  getHistory(startDT: Date, endDT: Date): Observable<any> {
    return this.http
      .get(
        `/api/v1/enrich_history?start=${startDT.toISOString()}&end=${endDT.toISOString()}`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/enrich.service.ts